import InputSelector from './RegularInputSelector';

export default InputSelector;
